import { DebugService } from './debug.service.js';

export class _HostAppEventsService {
  constructor() {
    this.debug = new DebugService('HostAppEventsService');
  }

  sendNextStepEvent(step) {
    document.dispatchEvent(
      new CustomEvent('next-step', {
        bubbles: true,
        composed: true,
        detail: {
          step,
          sentFrom: 'esign',
        },
      }),
    );
  }

  sendNextMfeEvent(updateMfeOrder = false, sentFrom = 'esign') {
    document.dispatchEvent(
      new CustomEvent('next-mfe', {
        bubbles: true,
        composed: true,
        detail: {
          sentFrom,
          updateMfeOrder,
        },
      }),
    );
  }

  sendPreviousMfeEvent() {
    document.dispatchEvent(
      new CustomEvent('previous-mfe', {
        bubbles: true,
        composed: true,
        detail: {
          sentFrom: 'esign',
        },
      }),
    );
  }

  sendInitiateAnimationCompletionEvent({ showCompletionAnimation, skipCurtainCloseAnimation, successAnimationLength }) {
    const data = {
      ...(showCompletionAnimation !== undefined && { showCompletionAnimation }),
      ...(skipCurtainCloseAnimation !== undefined && { skipCurtainCloseAnimation }),
      ...(successAnimationLength !== undefined && { successAnimationLength }),
    };

    document.dispatchEvent(
      new CustomEvent('initiate-animation-completion', {
        bubbles: true,
        composed: true,
        // The host reads these fields flat off `event.detail` (see
        // InitiateAnimationCompletionEvent in the host app), so the payload must
        // be the detail itself — wrapping it under `detail.data` dropped the
        // showCompletionAnimation flag and the success check mark never rendered.
        detail: data,
      }),
    );
  }

  sendInitiateAnimationTransitionEvent({ animationName, skipCurtainCloseAnimation, minimumAnimationLengthMs, animationText, animationDescription, animationSubtext, animationFooterText }) {
    document.dispatchEvent(
      new CustomEvent('initiate-animation-transition', {
        bubbles: true,
        composed: true,
        detail: {
          animationName,
          skipCurtainCloseAnimation,
          minimumAnimationLengthMs,
          animationText,
          ...(animationDescription !== undefined && { animationDescription }),
          ...(animationSubtext !== undefined && { animationSubtext }),
          ...(animationFooterText !== undefined && { animationFooterText }),
        },
      }),
    );
  }

  hideLoaderSpinnerEvent() {
    document.dispatchEvent(
      new CustomEvent('hide-loader-spinner', {
        bubbles: true,
        composed: true,
      }),
    );
  }

  sendGenericEvent(eventName) {
    document.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        composed: true,
      }),
    );
  }
}

export const HostAppEventsService = new _HostAppEventsService();
